import keyMirror from 'keymirror'

export default keyMirror({
  GET_RIDER_LIST_SUCCESS: null,
  GET_RIDER_LIST_REQUEST: null,
  GET_RIDER_LIST_FAILED: null,

  GET_RIDER_DETAIL_SUCCESS: null,
  GET_RIDER_DETAIL_REQUEST: null,
  GET_RIDER_DETAIL_FAILED: null,

  GET_RIDER_PORTAL_ROLE_SUCCESS: null,
  GET_RIDER_PORTAL_ROLE_REQUEST: null,
  GET_RIDER_PORTAL_ROLE_FAILED: null,

  UPDATE_FILTER_RIDER_SUCCESS: null
})
